import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { AppTopbar } from './AppTopbar';
import { ProtectedRoute } from '@/routes/guards';
import { LoadingState } from '@/components/app/LoadingState';

const COLLAPSE_KEY = 'admin-panel.sidebar-collapsed';

function readInitialCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  const stored = window.localStorage.getItem(COLLAPSE_KEY);
  if (stored != null) return stored === '1';
  return window.innerWidth < 1024;
}

export function AppLayout() {
  const [collapsed, setCollapsed] = React.useState<boolean>(() => readInitialCollapsed());

  const toggle = React.useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0');
      } catch {
        /* storage disabled */
      }
      return next;
    });
  }, []);

  return (
    <ProtectedRoute>
      <div className="flex h-full overflow-hidden">
        <AppSidebar collapsed={collapsed} />
        <div className="flex min-w-0 flex-1 flex-col">
          <AppTopbar onToggleSidebar={toggle} />
          <main className="flex-1 overflow-y-auto scrollbar-thin bg-background">
            <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6">
              <React.Suspense fallback={<LoadingState label="Loading page" />}>
                <Outlet />
              </React.Suspense>
            </div>
          </main>
        </div>
      </div>
    </ProtectedRoute>
  );
}
